export { default as Smv_Ov_List } from './page'


// WEBPACK FOOTER //
// ./src/pages/listSMV/index.js